import { render, staticRenderFns } from "./BotView.html?vue&type=template&id=4872645e&scoped=true&"
import script from "./BotView.js?vue&type=script&lang=js&"
export * from "./BotView.js?vue&type=script&lang=js&"
import style0 from "./BotView.scss?vue&type=style&index=0&id=4872645e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872645e",
  null
  
)

export default component.exports